import { api } from '../api';
import {setIsSuccess} from "../../store/reducers/notificationSlice";

const authApi = api.injectEndpoints({
    endpoints: (build) => ({
        registerUser: build.mutation({
            query: (payload) => ({
                url: '/public/register',
                method: 'POST',
                body: { ...payload, username: payload.email, role: 'private_user' }
            })
        }),
        authUser: build.mutation({
            query: (payload) => ({
                url: '/public/auth',
                method: 'POST',
                body: { ...payload }
            })
        }),
        resetPassword: build.mutation({
            query: (payload) => ({
                url: '/public/reset-pass-email',
                method: 'POST',
                body: { ...payload }
            })
        }),
        resetPasswordNew: build.mutation({
            query: (payload) => ({
                url: `/public/reset-pass?username=${payload.username}`,
                method: 'PATCH',
                body: { new_password: payload.new_password }
            })
        }),
        changePassword: build.mutation({
            query: (payload) => ({
                url: '/oauth/change-pass',
                method: 'POST',
                body: { ...payload }
            })
        }),
        confirmRegistration: build.mutation({
            query: (token) => ({
                url: `/public/registration-confirm?registration_token=${token}`,
                method: 'GET'
            })
        }),
        confirmResetPassword: build.mutation({
            query: (token) => ({
                url: `/public/reset-pass-confirm-email?token=${token}`,
                method: 'GET'
            })
        }),
    })
});

export const {
    useRegisterUserMutation,
    useAuthUserMutation,
    useResetPasswordMutation,
    useResetPasswordNewMutation,
    useChangePasswordMutation,
    useConfirmRegistrationMutation,
    useConfirmResetPasswordMutation
} = authApi;
